export enum OrderErrorCode {
    NONE = "",
    FAIL_PREPARE_ORDER = "fail_prepare_order"
}
